import { useEffect } from 'react';
import ArticuloForm from '../../components/articulos/ArticuloForm';
import { useArticulosStore, type RegistrarArticulo } from '../../stores/articulos/articulos.store';

const AgregarArticulo = () => {
  const { current: articulo, nuevo, registrar } = useArticulosStore((state) => state);

  useEffect(() => {
    nuevo();
  }, []);

  const handleSave = (values: RegistrarArticulo) => {
    return registrar(values);
  };

  return <ArticuloForm esAgregar={true} articulo={articulo} onSave={handleSave} />;
};

export default AgregarArticulo;
